enum ConnectionType {
  WEB = "WEB",
  QR_CODE_WEB = "QR_CODE_WEB",
  MENTOR_MATCHING = "MENTOR_MATCHING",
}

export default ConnectionType;
